import React from "react";

const TYPE_CLASSES = {
  checkbox: "checkbox",
};

const CheckboxInput = ({ label, inputType, ...otherProps }) => {
  return (
    <div>
      <input className={`input-${TYPE_CLASSES[inputType]}`} {...otherProps} />
      <label className={`label-${TYPE_CLASSES[inputType]}`}>{label}</label>
    </div>
  );
};

export default CheckboxInput;
